/* ll-pdp-reviews.js · Llama Land product page reviews (sections/ll-pdp-reviews.liquid), owner: product builder.
   The homepage reviews behaviour from assets/ll-home.js (common UI, no GSAP), scoped to each [data-ll-pdp-rev] section so
   nothing reaches outside it and two copies on one page stay independent:
     - customer videos: muted previews behind the Play/Pause chip (WCAG 2.2.2). As on the homepage in motion mode, previews
       start once the rail comes near, unless the visitor prefers reduced motion; only in-view previews play; the chip stops them.
     - tap a video: the sound dialog, titled with the kid's words; closing pauses it and hands focus back.
     - job chips (Brad 10-14): tapping a chip shows only that job's cards, All restores them; a polite live region says
       which group and how many. Show More and the phone row both work on the current set.
     - Show More Reviews: opens the extra postcards of the current set in place.
     - phone (max-width 767px): the review list becomes a one-at-a-time row with prev / dots / count / next.
   Near-detection mirrors ll-motion-boot's near(): IntersectionObserver plus a throttled scroll sweep and timed sweeps, because
   observer-less panes never fire IntersectionObserver. Re-inits on shopify:section:load (theme editor). */
(function () {
  'use strict';
  var D = document, W = window;
  var $ = function (s, r) { return (r || D).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var reduce = W.matchMedia('(prefers-reduced-motion: reduce)');

  /* run fn once when el is within ~1.5 viewports (observer) or 3 viewports (sweeps) */
  function near(el, fn) {
    var done = false, io = null, t = 0;
    function go() { if (done) return; done = true; if (io) io.disconnect(); W.removeEventListener('scroll', onS); fn(); }
    function sweep() { if (done) return; var r = el.getBoundingClientRect(), vh = W.innerHeight; if (r.bottom > -3 * vh && r.top < 4 * vh) go(); }
    function onS() { if (!t) t = setTimeout(function () { t = 0; sweep(); }, 150); }
    if ('IntersectionObserver' in W) {
      io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) go(); }, { rootMargin: '150% 0px' });
      io.observe(el);
    }
    W.addEventListener('scroll', onS, { passive: true });
    setTimeout(sweep, 4000);
  }

  function init(root) {
    if (!root || root.__llRev) return; root.__llRev = 1;
    var su = $('svg use', root), sprite = su ? (su.getAttribute('href') || '').split('#')[0] : '';

    /* ---------- video dialog ---------- */
    var dlg = $('dialog.ll-c-dlog-video', root), player = dlg ? $('video', dlg) : null, vt = dlg ? $('.ll-c-dlog-head h2', dlg) : null;
    function openDialog(opener) {
      if (!dlg || typeof dlg.showModal !== 'function' || dlg.open) return false;
      $$('dialog[open]').forEach(function (o) { if (o !== dlg && o.close) o.close(); });
      dlg.__opener = opener || null;
      dlg.showModal();
      return true;
    }
    if (dlg) {
      $$('.ll-c-dlog-x', dlg).forEach(function (x) { x.addEventListener('click', function () { dlg.close(); }); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      dlg.addEventListener('close', function () {
        if (player) { try { player.pause(); } catch (err) {} }
        var o = dlg.__opener; if (o && D.contains(o) && !$('dialog[open]')) { try { o.focus({ preventScroll: true }); } catch (err) {} }
      });
    }
    $$('.ll-c-vid-open', root).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!player) return;
        if (b.getAttribute('data-poster')) player.setAttribute('poster', b.getAttribute('data-poster'));
        player.setAttribute('src', b.getAttribute('data-video')); player.muted = false;
        if (vt) vt.textContent = b.getAttribute('data-quote') || vt.getAttribute('data-default') || vt.textContent;
        if (openDialog(b)) { var p = player.play(); if (p && p.catch) p.catch(function () {}); }
      });
    });

    /* ---------- muted previews behind the Play/Pause chip ---------- */
    var previews = $$('.ll-c-vid-prev', root), pv = $('.ll-c-pv-btn', root), on = false;
    function loadPreviews() { previews.forEach(function (v) { if (!v.getAttribute('src') && v.getAttribute('data-src')) v.setAttribute('src', v.getAttribute('data-src')); }); }
    function sync() {
      previews.forEach(function (v) {
        var r = v.getBoundingClientRect(), vis = r.bottom > 0 && r.top < W.innerHeight && r.right > 0 && r.left < W.innerWidth;
        var frac = vis ? (Math.min(r.bottom, W.innerHeight) - Math.max(r.top, 0)) / Math.max(1, r.height) : 0;
        if (on && frac > .6 && !D.hidden) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else if (!v.paused) v.pause();
      });
    }
    function setPreviews(v) {
      on = v; if (!pv) return;
      pv.setAttribute('aria-pressed', String(v));
      var sp = $('span', pv); if (sp) sp.textContent = v ? pv.getAttribute('data-pause') : pv.getAttribute('data-play');
      var u = $('use', pv); if (u) u.setAttribute('href', u.getAttribute('href').replace(/#i-(play|pause)$/, v ? '#i-pause' : '#i-play'));
      if (v) loadPreviews();
      sync();
    }
    if (pv && previews.length) {
      var touched = false;
      pv.addEventListener('click', function () { touched = true; setPreviews(!on); });
      var t = 0; W.addEventListener('scroll', function () { if (!on) return; clearTimeout(t); t = setTimeout(sync, 450); }, { passive: true });
      D.addEventListener('visibilitychange', sync);
      var rail = $('.ll-c-rv-videos', root);
      if (rail && !reduce.matches) near(rail, function () { if (!touched) setPreviews(true); });
    }
    root.__llRevPreviews = setPreviews;

    /* ---------- job chips + Show More Reviews + the phone review row ----------
       One state drives all three: key = the pressed chip ('all' or a job handle), opened = Show More was used.
       Desktop: the first data-visible cards of the current set show, Show More opens the rest of that set.
       Phone: the row holds exactly the current set; its dots / count / prev / next are rebuilt on every chip change. */
    var list = $('.ll-c-rv-list', root); if (!list) return;
    var wrap = list.closest('.ll-c-rv-rail-wrap') || list.parentNode, more = $('.ll-c-rv-more-btn', root);
    var mq = W.matchMedia('(max-width: 767px)'), nav = null, opened = false, cur = 0, key = 'all';
    var vc = parseInt(list.getAttribute('data-visible'), 10) || 3;
    var cards = $$('.ll-c-rv', list);
    var chips = $('[data-ll-pdp-rev-chips]', root), live = $('[data-ll-pdp-rev-live]', root);
    var L = function (k, n, tot) { return (list.getAttribute('data-' + k) || '').replace('[n]', n).replace('[total]', tot); };
    function inSet(c) { return key === 'all' || c.getAttribute('data-job') === key; }
    function slides() { return cards.filter(inSet); }
    function step() { var s = slides(); return s.length > 1 ? s[1].offsetLeft - s[0].offsetLeft : list.clientWidth; }
    function go(i) { var n = slides().length; i = clamp(i, 0, n - 1); list.scrollTo({ left: i * step(), behavior: reduce.matches ? 'auto' : 'smooth' }); }
    function mark() {
      if (!nav) return;
      var n = slides().length, i = clamp(Math.round(list.scrollLeft / Math.max(1, step())), 0, Math.max(0, n - 1));
      cur = i;
      $$('.ll-c-rv-dots button', nav).forEach(function (b, j) { b.setAttribute('aria-current', String(j === i)); });
      $('.ll-c-rv-count', nav).textContent = L('count', i + 1, n);
      $('.ll-c-rv-prev', nav).disabled = i === 0; $('.ll-c-rv-next', nav).disabled = i >= n - 1;
      slides().forEach(function (s, j) { s.setAttribute('aria-hidden', String(j !== i)); });
    }
    /* show / hide cards for the current key and mode; returns the cards newly revealed by Show More */
    function apply() {
      var set = slides(), row = !!nav;
      cards.forEach(function (c) { c.hidden = true; c.removeAttribute('aria-hidden'); });
      set.forEach(function (c, i) { c.hidden = !(row || opened || i < vc); });
      if (more) more.parentNode.hidden = row || opened || set.length <= vc;
      if (more) more.setAttribute('aria-expanded', String(opened || set.length <= vc));
      if (row) {
        var n = set.length, dots = '';
        for (var i = 0; i < n; i++) dots += '<button type="button" aria-label="' + L('dot', i + 1, n) + '" aria-current="false" data-heatmap-id="ll-pdp-rev-dot-' + (i + 1) + '"></button>';
        var d = $('.ll-c-rv-dots', nav); d.innerHTML = dots;
        $$('button', d).forEach(function (b, j) { b.addEventListener('click', function () { go(j); }); });
        nav.hidden = n < 2;
        list.scrollLeft = 0; cur = 0; mark();
      }
      return set;
    }
    if (more) more.addEventListener('click', function () {
      opened = true;
      var first = slides()[vc];
      apply();
      if (first) { first.setAttribute('tabindex', '-1'); first.focus({ preventScroll: true }); }
    });
    if (chips) {
      var btns = $$('[data-job]', chips);
      chips.hidden = false;
      chips.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-job]') : null;
        if (!b || !chips.contains(b)) return;
        key = b.getAttribute('data-job') || 'all';
        btns.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        var n = apply().length;
        if (live) live.textContent = (live.getAttribute('data-tpl') || '').replace('…', b.getAttribute('data-name') || b.textContent.trim()).replace('[count]', n);
      });
    }
    function onRow() {
      if (nav) return;
      wrap.classList.add('ll-c-rv-carousel');
      list.setAttribute('aria-roledescription', 'carousel'); list.setAttribute('aria-label', list.getAttribute('data-label') || '');
      nav = D.createElement('div'); nav.className = 'll-c-rv-nav'; nav.setAttribute('role', 'group'); nav.setAttribute('aria-label', list.getAttribute('data-nav-label') || '');
      nav.innerHTML = '<button type="button" class="ll-c-rv-step ll-c-rv-prev" aria-label="' + (list.getAttribute('data-prev') || '') + '" data-heatmap-id="ll-pdp-rev-prev"><svg aria-hidden="true"><use href="' + sprite + '#i-left"/></svg></button>'
        + '<div class="ll-c-rv-dots"></div><span class="ll-c-rv-count" aria-live="polite"></span>'
        + '<button type="button" class="ll-c-rv-step ll-c-rv-next" aria-label="' + (list.getAttribute('data-next') || '') + '" data-heatmap-id="ll-pdp-rev-next"><svg aria-hidden="true"><use href="' + sprite + '#i-right"/></svg></button>';
      list.parentNode.insertBefore(nav, list.nextSibling);
      $('.ll-c-rv-prev', nav).addEventListener('click', function () { go(cur - 1); });
      $('.ll-c-rv-next', nav).addEventListener('click', function () { go(cur + 1); });
      apply();
    }
    function offRow() {
      if (!nav) return;
      nav.remove(); nav = null; wrap.classList.remove('ll-c-rv-carousel');
      list.removeAttribute('aria-roledescription'); list.removeAttribute('aria-label');
      apply();
    }
    var st = 0;
    list.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(mark, 60); }, { passive: true });
    function syncRow() { if (mq.matches) onRow(); else offRow(); }
    if (mq.addEventListener) mq.addEventListener('change', syncRow); else if (mq.addListener) mq.addListener(syncRow);
    W.addEventListener('resize', function () { if (nav) mark(); });
    syncRow();
  }

  function boot() { $$('[data-ll-pdp-rev]').forEach(init); }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
  D.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector ? e.target.querySelector('[data-ll-pdp-rev]') : null; if (r) init(r); });
})();
